import React from "react";
import "./newuo-story-box.m.css"; // Import CSS file for styling
import { Link } from "@quintype/components";
import TimeStamp from "../../atoms/time-stamp";
import StarShowHide from "../../atoms/star-show-hide";
import { BookmarkIcon } from "../bookmark-icon";
import { CommentIcon } from "../comment-icon";

const NewuoStoryBox = ({ articleURL, imageSrc, publicationID, headline, publishedDate, pubDate, accessType, score, storyObj }) => {
  const parts = articleURL.split('/');
  const lastPart = parts[parts.length - 1];
  return (

      <div styleName="story-box">
        {/*imageSrc ? (
          <img src={imageSrc} alt={lastPart} styleName="story-image" />
        ) : null*/}
        <div styleName="publication-info">
          <Link href={articleURL}><h2 styleName="headline">{headline}</h2></Link>
          <div styleName="time-star-wrapper">
            <TimeStamp timeStamp={pubDate}  prefix={publicationID} showTime={false} />
            <StarShowHide accessType={accessType} />
            <CommentIcon storyObj={storyObj} />
            <BookmarkIcon user_flag="bm_user_flag" storyObj={storyObj} showBookmark={true} removeStory={false} />
          </div>
          {/*console.log("score: ", headline, score)*/}
        </div>
      </div>

  );
};

export default NewuoStoryBox;
